module.exports = __webpack_public_path__ + "static/media/qrCodeArrowRight.svg";